import React from 'react'

import LoaderContext from 'contexts/LoaderContext'

const useLoader = () => {
  const loaderContext = React.useContext(LoaderContext)

  if (loaderContext === undefined) {
    throw new Error('useLoader must be used within a LoaderContext.Provider')
  }

  const open = ({ align = 'center', title, message }) =>
    loaderContext.setState({ open: true, align, title, message })

  const hide = () =>
    loaderContext.setState({ open: false, title: '', message: '' })

  return {
    open,
    hide,
  }
}

export default useLoader
